import Vue from 'vue'
import Router from 'vue-router'

import Auth from './views/Auth'
import Recovery from './views/Recovery'
import Erro404 from './views/Erro404'

import Overview from './views/Overview'

import Properties from './views/Properties/index.vue'
import listProperties from './views/Properties/list.vue'
import addProperties from './views/Properties/add.vue'
import editProperties from './views/Properties/edit.vue'

import News from './views/News/index.vue'
import listNews from './views/News/list.vue'
import addNews from './views/News/add.vue'
import editNews from './views/News/edit.vue'

import Advertisers from './views/Advertisers/index.vue'
import listAdvertisers from './views/Advertisers/list.vue'

import Newsletters from './views/Newsletters/index.vue'
import listNewsletters from './views/Newsletters/list.vue'

import Api from './views/Api/index.vue'

import Contacts from './views/Contacts/index.vue'
import listContacts from './views/Contacts/list.vue'

import Banners from './views/Banners/index.vue'
import listBanners from './views/Banners/list.vue'
import addBanners from './views/Banners/add.vue'
import editBanners from './views/Banners/edit.vue'

import Users from './views/Users/index.vue'
import listUsers from './views/Users/list.vue'
import addUsers from './views/Users/add.vue'
import editUsers from './views/Users/edit.vue'

import Rantings from './views/Rantings/index.vue'
import listRantings from './views/Rantings/list.vue'

import Surveys from './views/Surveys/index.vue'
import listSurveys from './views/Surveys/list.vue'
import replySurveys from './views/Surveys/reply.vue'

import Cookies from "vue-cookie";

Vue.use(Router)

const routes = [
    {
        path: '/',
        component: Overview,
        name: 'overview',
        meta: {requiresAuth: true}
    },
    {
        path: '/surveys',
        component: Surveys,
        meta: {requiresAuth: true},
        props: true,
        children: [
            {
                path: '',
                component: listSurveys,
                meta: {requiresAuth: true},
                props: true
            },{
                path: '/reply',
                component: replySurveys,
                meta: {requiresAuth: true},
                props: true
            }
        ]
    },
    {
        path: '/rantings',
        component: Rantings,
        meta: {requiresAuth: true},
        props: true,
        children: [
            {
                path: '',
                component: listRantings,
                meta: {requiresAuth: true},
                props: true
            }
        ]
    },
    {
        path: '/advertisers',
        component: Advertisers,
        meta: {requiresAuth: true},
        props: true,
        children: [
            {
                path: '',
                component: listAdvertisers,
                meta: {requiresAuth: true},
                props: true
            }
        ]
    },
    {
        path: '/apis',
        component: Api,
        meta: {requiresAuth: true},
        props: true
    },
    {
        path: '/newsletters',
        component: Newsletters,
        meta: {requiresAuth: true},
        props: true,
        children: [
            {
                path: '',
                component: listNewsletters,
                meta: {requiresAuth: true},
                props: true
            }
        ]
    },
    {
        path: '/contacts',
        component: Contacts,
        meta: {requiresAuth: true},
        props: true,
        children: [
            {
                path: '',
                component: listContacts,
                meta: {requiresAuth: true},
                props: true
            }
        ]
    },
    {
        path: '/news',
        component: News,
        meta: {requiresAuth: true},
        props: true,
        children: [
            {
                path: '/news',
                component: listNews,
                meta: {requiresAuth: true},
                props: true
            },
            {
                path: '/news/add',
                component: addNews,
                name: 'news-add',
                meta: {requiresAuth: true},
                props: true
            },
            {
                path: '/news/edit',
                name: 'news-edit',
                component: editNews,
                meta: {requiresAuth: true},
                props: true
            }
        ]
    },
    {
        path: '/banners',
        component: Banners,
        meta: {requiresAuth: true},
        props: true,
        children: [
            {
                path: '/banners',
                component: listBanners,
                meta: {requiresAuth: true},
                props: true
            },
            {
                path: '/banners/add',
                name: 'banners-add',
                component: addBanners,
                meta: {requiresAuth: true},
                props: true
            },
            {
                path: '/banners/edit',
                component: editBanners,
                meta: {requiresAuth: true},
                props: true
            }
        ]
    },
    {
        path: '/properties',
        component: Properties,
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'properties',
                component: listProperties,
                meta: {requiresAuth: true},
                props: true
            },
            {
                path: '/properties/add',
                name: 'properties-add',
                component: addProperties,
                meta: {requiresAuth: true},
                props: true
            },
            {
                path: '/properties/edit',
                name: 'properties-edit',
                component: editProperties,
                meta: {requiresAuth: true},
                props: true
            }
        ]
    },
    {
        path: '/users',
        component: Users,
        meta: {requiresAuth: true},
        props: true,
        children: [
            {
                path: '/users',
                name: 'users',
                component: listUsers,
                meta: {requiresAuth: true},
                props: true
            },
            {
                path: '/users/add',
                name: 'users-add',
                component: addUsers,
                meta: {requiresAuth: true},
                props: true
            },
            {
                path: '/users/edit',
                name: 'users-edit',
                component: editUsers,
                meta: {requiresAuth: true},
                props: true
            }
        ]
    },
    {
        path: '/auth',
        name: 'auth',
        component: Auth,
        props: true
    },
    {
        path: '/recovery',
        name: 'recovery',
        component: Recovery,
        props: true
    },
    {path: '/*', component: Erro404, name: 'error'}
]

const router = new Router({
    base: process.env.BASE_URL,
    routes,
    hashbang: false,
    history: true,
    mode: 'history'
})

router.beforeEach((to, from, next) => {
    var session = '';
    if (JSON.parse(Cookies.get('c_extra')) != null) {
        session = JSON.parse(Cookies.get('c_extra'))
    }
    if (to.meta.requiresAuth) {
            if (session.token) {
                next()
            } else {
                router.push('/auth')
            }
        }
    next()
})

export default router
